module.exports = __webpack_public_path__ + "static/media/Diagramas_imagen-05.ae639364.png";